export default "__VITE_ASSET__CgXMak4Q__"